import { buildQuery, parseQuery } from '@calendly/http-tools'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

export const historyPush = (path) => (dispatch, getState, { history }) => history.push(path)

export const redirectTo = (url) => () => { window.top.location.href = url }

export const openAndFocusTo = (url) => () => { window.open(url, '_blank').focus() }

export const reload = () => window.location.reload()

const historyReplace = (path) => (dispatch, getState, { history }) => history.replace(path)

export const historyReplacePathname = (pathname) => (dispatch, getState, { history }) => {
  const currentSearch = history.location.search
  return dispatch(historyReplace({ pathname, search: currentSearch }))
}

export const setGetParams = (params) => (dispatch, getState, { history }) => {
  const searchParams = parseQuery(history.location.search)
  Object.entries(params).forEach(([key, value]) => {
    if (value === null) {
      delete searchParams[key]
    } else {
      searchParams[key] = value
    }
  })

  const searchStr = buildQuery(searchParams, { addQueryPrefix: true })
  return dispatch(historyReplace({ search: searchStr }))
}

export const pushGetParams = (params) => (dispatch, getState, { history }) => {
  const searchParams = parseQuery(history.location.search)
  Object.entries(params).forEach(([key, value]) => {
    if (value === null) {
      delete searchParams[key]
    } else {
      searchParams[key] = value
    }
  })

  const searchStr = buildQuery(searchParams, { addQueryPrefix: true })
  return dispatch(historyPush({ search: searchStr }))
}

export const pushQueryParams = (params) => (dispatch, getState, { history }) => {
  const newQueryString = buildQuery(params, { addQueryPrefix: true })
  history.push({ search: newQueryString })
}

const getHostname = (address) => {
  const link = document.createElement('a')
  link.href = address
  return link.hostname
}

export const useReturnTo = () => {
  const { search } = useLocation()
  const { return_to: returnTo } = parseQuery(search)
  const hostName = useMemo(() => getHostname(returnTo), [returnTo])

  if (
    !returnTo
      || !returnTo.startsWith('/')
      || hostName !== window.location.hostname) { return null }
  return returnTo
}
